import type { FunctionComponent } from 'react';

import { TickList } from '@kanda-libs/ks-design-library-new';

import { CLASS_NAMES } from './constants';
import useSelectedRatePreApprovalMessage from './useSelectedRatePreApprovalMessage';

import type { CheckoutFinanceRate } from '../constants';

export interface SelectedRatePreApprovalMessageProps {
  selectedRate: CheckoutFinanceRate;
}

const SelectedRatePreApprovalMessage: FunctionComponent<SelectedRatePreApprovalMessageProps> =
  function ({ selectedRate }) {
    const { rows } = useSelectedRatePreApprovalMessage(selectedRate);

    return (
      <div className={CLASS_NAMES.wrapper}>
        <TickList rows={rows} tickStroke="lavender-300" />
      </div>
    );
  };

export default SelectedRatePreApprovalMessage;
